import React, { useState } from 'react';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { SupportModal } from './supportModal';
import { MyCalendlyComponent } from 'pages/landing/contactUs/fragments/myCalendlyComponent';
import { CALENDLY_URL } from 'utils';

const SUPPORT_VIEW = {
    MENU: 'MENU',
    REQUEST: 'REQUEST',
    MEETING: 'MEETING',
};

export const SupportModalSelector = () => {
    const [view, setView] = useState(SUPPORT_VIEW.MENU);

    if (view === SUPPORT_VIEW.REQUEST) {
        return (
            <div style={{ width: 400, height: 550 }}>
                <div className="support-selector-subheader">
                    <button type="button" className="support-selector-back-btn" onClick={() => setView(SUPPORT_VIEW.MENU)}>
                        <ArrowBackRoundedIcon />
                    </button>
                    <p>Submit a support request</p>
                </div>
                <div className="support-selector-divider" />
                <SupportModal platform="Staff Portal" />
            </div>
        );
    }

    if (view === SUPPORT_VIEW.MEETING) {
        return (
            <div style={{ width: 1000, maxWidth: '100%' }}>
                <div className="support-selector-subheader">
                    <button type="button" className="support-selector-back-btn" onClick={() => setView(SUPPORT_VIEW.MENU)}>
                        <ArrowBackRoundedIcon />
                    </button>
                    <p>Schedule a support meeting</p>
                </div>
                <div className="support-selector-divider" />
                <MyCalendlyComponent url={CALENDLY_URL.SUPPORT_TRAINING} styles={{ height: '640px', width: '100%' }} />
            </div>
        );
    }

    return (
        <div style={{ width: 500 }}>
            <div className="support-selector-header">
                <div className="support-selector-header-icon">
                    <SupportAgentRoundedIcon fontSize="small" />
                </div>
                <p>Support</p>
            </div>

            <div className="support-selector-divider" />

            <p className="support-selector-subtitle">How would you like to get help today?</p>

            <div className="support-selector-option-list">
                <button type="button" className="support-selector-option" onClick={() => setView(SUPPORT_VIEW.REQUEST)}>
                    <div className="support-selector-option-icon">
                        <ChatBubbleOutlineRoundedIcon fontSize="small" />
                    </div>
                    <div className="support-selector-option-body">
                        <div className="support-selector-option-title-row">
                            <span className="support-selector-option-title">Submit a support request</span>
                        </div>
                        <p className="support-selector-option-description">
                            Send us the details of an issue. Best for bugs, account changes and anything with screenshots.
                        </p>
                        <div className="support-selector-option-meta">
                            <AccessTimeRoundedIcon />
                            <span>Reply within 1 business day</span>
                        </div>
                    </div>
                    <ChevronRightRoundedIcon className="support-selector-chevron" />
                </button>

                <button type="button" className="support-selector-option" onClick={() => setView(SUPPORT_VIEW.MEETING)}>
                    <div className="support-selector-option-icon">
                        <VideocamOutlinedIcon fontSize="small" />
                    </div>
                    <div className="support-selector-option-body">
                        <div className="support-selector-option-title-row">
                            <span className="support-selector-option-title">Schedule a support meeting</span>
                            <span className="support-selector-fastest-badge">Fastest</span>
                        </div>
                        <p className="support-selector-option-description">
                            Book a live video call with a TherapyLake specialist. Best for walkthroughs, training and complex setup.
                        </p>
                        <div className="support-selector-option-meta">
                            <AccessTimeRoundedIcon />
                            <span>30 min · pick a time now</span>
                        </div>
                    </div>
                    <ChevronRightRoundedIcon className="support-selector-chevron" />
                </button>
            </div>
        </div>
    );
};
